import { Outlet, createFileRoute, useLocation } from "@tanstack/react-router";
import AppBarContactDirectory from "./-components/AppBar";
import FilterTeams from "./-components/FilterTeams";

export const Route = createFileRoute("/dashboard/contacts")({
	component: RouteComponent,
});

const layoutWhitelist = [
	"/dashboard/contacts/contact",
	"/dashboard/contacts/contact/teams",
	"/dashboard/contacts/directory",
	"/dashboard/contacts/directory/teams",
] as const;

function RouteComponent() {
	const { isTeams, isShowLayout } = useLocation({
		select: (state) => ({
			isTeams: state.pathname.includes("teams"),
			isShowLayout: layoutWhitelist.some((path) => state.pathname === path),
		}),
	});
	if (isShowLayout === false) return <Outlet />;
	return (
		<div className="relative h-full bg-gray-light flex flex-col">
			<AppBarContactDirectory />
			{isTeams ? <FilterTeams /> : null}
			<div className="relative flex-1 overflow-hidden">
				<Outlet />
			</div>
		</div>
	);
}
